ProductReviews = window.ProductReviews ?= {}
ProductReviews.Views ?= {}
ProductReviews.Templates ?= {}

ProductReviews.Templates['product_reviews_user_review'] = require '../../user_review.html.mustache'
ProductReviews.Views.ReviewCard = require './product_reviews_review_card'
ProductReviews.Views.ReviewRating = require './product_reviews_review_rating'

ProductReviews.Views.UserReview = Backbone.View.extend
  el: "#user-review-card"

  render: ->
    $('#product-reviews-form-extension').after ProductReviews.Templates['product_reviews_user_review'].render(userReview: @model.attributes)
    @setElement $('#user-review-card')
    (new ProductReviews.Views.ReviewCard model: @model, el: "#user-review-card").render()
    (new ProductReviews.Views.ReviewRating model: @model, el: "#user-review-card .review-rating").render()


module.exports = ProductReviews.Views.UserReview
